import styles from './PlacingOrderHeader.module.scss';
import Box from '@components/Box';
import { Column, Row } from '@components/Grid';
import { IPlacingOrderHeaderProps } from './types';
import { Text, TextColor, TextType } from '@components/Text';
import { useTranslation } from 'react-i18next';

const PlacingOrderHeader: React.FC<IPlacingOrderHeaderProps> = (props: IPlacingOrderHeaderProps): React.ReactElement => {
  const { currentStep, description, numberOfSteps, title } = props;

  const { t } = useTranslation();

  return (
      <>
        <Row>
          <Column phone={12}>
            <Box mb={5}>
              <div className={styles.title}>
                <Text type={TextType.H1}>
                  {title}
                </Text>
                {!!currentStep && !!numberOfSteps && (
                    <Text
                        color={TextColor.DARK_MUTED}
                        type={TextType.SPAN}
                    >
                      {t('placingOrderModalWindow.step', { currentStep, numberOfSteps })}
                    </Text>
                )}
              </div>
            </Box>
          </Column>
        </Row>
        {description && (
            <Row>
              <Column phone={12}>
                <Box mb={5}>
                  <Text type={TextType.SPAN}>
                    {description}
                  </Text>
                </Box>
              </Column>
            </Row>
        )}
      </>
  );
};

export default PlacingOrderHeader;